import firebase from "firebase/app";
import "firebase/database";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_INSIGHT_API_KEY,
  authDomain: process.env.REACT_APP_INSIGHT_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_INSIGHT_DATABASE_URL,
  projectId: process.env.REACT_APP_INSIGHT_PROJECT_ID,
  storageBucket: process.env.REACT_APP_INSIGHT_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_INSIGHT_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_INSIGHT_APP_ID,
  measurementId: process.env.REACT_APP_INSIGHT_MEASUREMENT_ID
};

// Add the other Firebase project's config here
const secondaryApp = firebase.initializeApp(firebaseConfig, "Secondary");
export const secondaryDb = secondaryApp.database();
